<template>
  <v-container v-if="lottery">
    <h1>Vinlotteri Detaljer</h1>
    <v-row>
      <v-col cols="12" md="6">
        <p><strong>Tema:</strong> {{ lottery.theme }}</p>
        <p><strong>Dato:</strong> {{ formatDate(lottery.date) }}</p>
      </v-col>
    </v-row>
  
    <h2>Wines</h2>
  
    <v-table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Description</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="wine in lottery.wines" :key="wine._id">
          <td>{{ wine.name }}</td>
          <td>{{ wine.description }}</td>
        </tr>
        <tr>
          <td>
            <v-text-field v-model="newWine.name" label="Name" outlined dense></v-text-field>
          </td>
          <td>
            <v-text-field v-model="newWine.description" label="Description" outlined dense></v-text-field>
          </td>
          <td>
            <v-btn color="primary" @click="addWine">Add</v-btn>
          </td>
        </tr>
      </tbody>
    </v-table>
      
    <v-btn color="primary" @click="submitWines" class="mt-4">Submit All Wines</v-btn>
    <v-btn color="success" @click="goToSpinningWheel" class="mt-4 ml-4">Start Lottery</v-btn>

    <v-snackbar v-model="snackbar" :color="snackbarColor">
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
  <v-container v-else>
    <h2>Loading lottery details...</h2>
  </v-container>
</template>
  
<script>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getAccessToken } from './authService';
import config from '@/config';

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();
    const lottery = ref(null);
    const newWine = ref({ name: '', description: '' });
    const snackbar = ref(false);
    const snackbarText = ref('');
    const snackbarColor = ref('info');
  
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        console.warn(`Invalid date format: ${dateString}`);
        return dateString;
      }
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    };
  
    const fetchLotteryDetails = () => {
      const lotteryId = route.params.id;
      console.log('Looking for lottery with ID:', lotteryId);
      
      const allLotteries = JSON.parse(localStorage.getItem('allLotteries')) || [];
      console.log('All lotteries from localStorage:', allLotteries);
      
      const foundLottery = allLotteries.find(l => l._id === lotteryId);
      console.log('Found lottery:', foundLottery);
      
      if (foundLottery) {
        lottery.value = {
          ...foundLottery,
          wines: foundLottery.wines || []
        };
        console.log('Set lottery value to:', lottery.value);
      } else {
        showSnackbar('Lottery details not found', 'error');
        console.warn('Lottery details are missing.');
      }
    };
  
    const addWine = () => {
      if (newWine.value.name && newWine.value.description) {
        if (!lottery.value.wines) {
          lottery.value.wines = [];
        }
        lottery.value.wines.push({ ...newWine.value });
        newWine.value = { name: '', description: '' };
      } else {
        showSnackbar('Please fill in both name and description.', 'error');
      }
    };
  
    const submitWines = async () => {
      try {
        const token = await getAccessToken();
        const response = await fetch(
          `${config.apiBaseUrl}/api/updateLottery/${lottery.value._id}`,
          {
            method: 'PUT',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ wines: lottery.value.wines }),
          }
        );
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const updatedLottery = await response.json();
        lottery.value = updatedLottery;
        showSnackbar('Wines submitted successfully!', 'success');
      } catch (error) {
        showSnackbar('Failed to submit wines.', 'error');
      }
    };

    const showSnackbar = (text, color) => {
      snackbarText.value = text;
      snackbarColor.value = color;
      snackbar.value = true;
    };

    const goToSpinningWheel = () => {
      router.push({ 
        name: 'SpinningWheel', 
        params: { id: lottery.value._id }
      });
    };

    onMounted(() => {
      fetchLotteryDetails();
    });

    return {
      lottery,
      formatDate,
      newWine,
      addWine,
      submitWines,
      snackbar,
      snackbarText,
      snackbarColor,
      goToSpinningWheel,
    };
  },
};
</script>

<style scoped>
h1 {
  margin-bottom: 20px;
}

h2 {
  margin-top: 30px;
}

.mt-4 {
  margin-top: 20px;
}

.ml-4 {
  margin-left: 20px;
}
</style>